<template>
  <div>
    <div class="row">
      <div class="col-8">
        <el-button size="small" type="warning" @click="onStart" v-if="!this.data"><i class="fa-solid fa-play"></i> Başla
        </el-button>
        <div v-else>
          <span style="background-color:#8E9A9B; color: white; padding:5px;">{{
            "Müştəri xidməti tərəfindən iş başlanmışdır: " + data.createdBy
          }}</span>
        </div>
      </div>
    </div>
    <br />
    <card  v-if="this.data" title="İşlər">
      <el-form v-loading="loading">
        <div @dblclick="clickCard(item.id)" class="row" v-for="item in claims" :key="item.id">
          <div class="col-12">
            <claim-card :item="item" @refresh="getData" />
          </div>
        </div>
      </el-form>
    </card>
  </div>
</template>

<script>
import {
  GetAccident,
  GetAccidentsByStatus,
  DeleteParticipant,
} from "../../services/accident";
import { GetClaimParticipants } from "../../services/common";
import ClaimCard from "../components/ClaimCard.vue";
export default {
  props: {
    id: [String, Number],
  },
  components: {
    ClaimCard,
    
  },
  data() {
    return {
      loading: false,
      item: {},
      data: {},
      claims: {},
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    clickCard(id) {
      this.$router.push({
        path: "../claim/" + id,
      });
    },
    openDialog() {
      this.rejectVisible = true;
    },
    getData() {
      this.loading = true;
      GetAccident(this.id).then((response) => {
        this.loading = false;
        if (response.data.data) {
           this.item = response.data.data?.[0]
          this.getDataByStatus();
          this.getClaimParticipants();
        } else {
          this.$message({
            type: "warning",
            message: "Səhv əməliyyat",
          });
        }
      });
    },
    getDataByStatus() {
      this.loading = true;
      GetAccidentsByStatus(this.id, 0, 40, this.uid).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.data = response.data.data;
        } else {
          this.data = null;
        }
      });
    },
    getClaimParticipants() {
      this.partloading = true;
      GetClaimParticipants(this.id).then((response) => {
        this.partloading = false;
        if (response.data.data) {
         this.claims = response.data.data;
        }
      });
    },


  
  },

  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>